module.exports = __webpack_public_path__ + "img/13.18bde209.gif";